var map = {
	"./account/account.module": [
		"./src/app/account/account.module.ts",
		"default~account-account-module~software-software-module",
		"account-account-module"
	],
	"./landing/landing.module": [
		"./src/app/landing/landing.module.ts",
		"landing-landing-module"
	],
	"./software/software.module": [
		"./src/app/software/software.module.ts",
		"default~account-account-module~software-software-module",
		"software-software-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;